'use client';

import Header from '@/components/common/Header';
import Footer from '@/app/homepage/components/Footer';
import { useSiteLanguage } from '@/lib/SiteLanguageContext';

export default function PrivacyPolicyPage() {
    const { siteLang } = useSiteLanguage();
    const en = siteLang === 'en';

    return (
        <main className={`min-h-screen no-top-gap bg-white flex flex-col`}>
            <Header />

            <section className="max-w-5xl mx-auto px-4 pt-24 pb-12">
                <h1 className="text-3xl font-bold mb-6">
                    {en ? 'Privacy Policy' : 'Politika privatnosti'}
                </h1>

                <p className="mb-4">{en
                    ? 'This Privacy Policy explains what data we collect about you, how we use that data, and provides all other relevant information regarding your data in connection with browsing and leaving comments on the site studijeodbrambenihsistema.com.'
                    : 'Ova Politika privatnosti služi da vam objasni koje podatke prikupljamo o vama i kako koristimo te podatke, kao i da vam pruži sve druge bitne informacije u vezi s vašim podacima, a u vezi s pretraživanjem i ostavljanjem komentara na sajtu studijeodbrambenihsistema.com.'
                }</p>

                <p className="mb-4">{en
                    ? 'This Privacy Policy supplements the Terms of Use on this site and amends them in the part relating to the protection of personal data, all in order to comply with the General Data Protection Regulation (GDPR).'
                    : 'Ova Politika privatnosti dopunjuje Pravila korištenja na ovom sajtu i mijenja ih u dijelu koji se odnosi na zaštitu ličnih podataka, a sve u cilju usklađivanja s Opštom uredbom o zaštiti podataka o ličnosti (GDPR).'
                }</p>

                <h2 className="text-xl font-semibold mt-6 mb-2">
                    {en ? 'Comments and Public Data' : 'Komentari i javni podaci'}
                </h2>
                <p className="mb-4">{en
                    ? 'On the blog studijeodbrambenihsistema.com, through the comment feature, users may leave comments on articles with content they define themselves, and under a name or pseudonym of their choosing.'
                    : 'Na blogu studijeodbrambenihsistema.com, u okviru funkcije ostavljanja komentara na vijesti na sajtu, studijeodbrambenihsistema.com omogućava korisnicima da ostave komentare na vijesti na sajtu sa sadržajem koji sami definišu, kao i pod imenom – pseudonimom koji sami odrede.'
                }</p>

                <p className="mb-4">{en
                    ? 'Therefore, in connection with leaving comments, and in accordance with your right to freedom of expression, you yourself choose what personal data, if any, you make available to the public, and whether we will have your personal data at all.'
                    : 'Stoga, u vezi s ostavljanjem komentara, u skladu s vašim pravom na slobodu izražavanja, vi sami birate koje ćete i da li ćete uopšte vaše lične podatke učiniti dostupnim javnosti i da li ćemo mi uopšte imati vaše lične podatke.'
                }</p>

                <p className="mb-4">{en
                    ? 'In addition to the information related to comments that you make public on our blog, we also collect the time and date of the comment, as well as the IP address from which the comment was posted.'
                    : 'Pored tih informacija u vezi s komentarima koje vi učinite javnim na našem blogu, mi prikupljamo i vrijeme i datum komentara, kao i IP adresu s koje je komentar postavljen.'
                }</p>

                <p className="mb-4">{en
                    ? 'All of the above data is collected solely for the purpose of enabling browsing of our site and leaving comments on articles.'
                    : 'Sve navedene podatke o vama prikupljamo isključivo u svrhu omogućavanja pretraživanja našeg sajta i ostavljanja komentara na vijesti.'
                }</p>

                <p className="mb-4">{en
                    ? 'By accessing the site and leaving comments, you accept the Terms of Use and this Privacy Policy, which are published on the site.'
                    : 'Samim pristupom sajtu i ostavljanjem komentara vi prihvatate Pravila korištenja, kao i ovu Politiku privatnosti, koji su istaknuti na samom sajtu.'
                }</p>

                <h2 className="text-xl font-semibold mt-6 mb-2">
                    {en ? 'Data Processing and Legitimate Interest' : 'Obrada podataka i legitimni interes'}
                </h2>
                <p className="mb-4">{en
                    ? 'In addition, we process your data based on our legitimate interest in order to detect and remove errors and technical issues that may arise in connection with browsing the site.'
                    : 'Pored toga, vaše podatke obrađujemo na osnovu našeg legitimnog interesa kako bismo otkrili i uklonili greške i tehničke probleme koji se mogu javiti u vezi s pretraživanjem sajta.'
                }</p>

                <p className="mb-4">{en
                    ? 'We may also process your data on the same basis in cases of potential account misuse, as well as to prevent such misuse in comments. This includes blocking comments that violate our Terms of Use and relevant legal regulations.'
                    : 'Također, vaše podatke po istom osnovu možemo obrađivati i u slučaju eventualnih zloupotreba naloga, kao i radi sprečavanja istih na komentarima. Ovo uključuje i blokiranje komentara koji krše naša Pravila korištenja i relevantne zakonske propise.'
                }</p>

                <h2 className="text-xl font-semibold mt-6 mb-2">
                    {en ? 'Disclosure of Data to Third Parties' : 'Otkriće podataka trećim licima'}
                </h2>
                <p className="mb-4">{en
                    ? 'We may disclose or share your data with certain government authorities if required by law.'
                    : 'Na kraju, vaše podatke možemo otkriti ili podijeliti s određenim državnim organima ako se to od nas zahtijeva na osnovu zakona.'
                }</p>

                <p className="mb-4">{en
                    ? 'We may also disclose data based on a legally grounded, written, judicial or other decision of a government authority that, under applicable regulations, enables access to personal data.'
                    : 'Također, iste možemo otkriti i na osnovu zakonom utemeljene, pisane, sudske ili druge odluke državnog organa kojom se, na osnovu relevantnih propisa, može omogućiti uvid u lične podatke.'
                }</p>

                <h2 className="text-xl font-semibold mt-6 mb-2">
                    {en ? 'Data Retention' : 'Čuvanje podataka'}
                </h2>
                <p className="mb-4">{en
                    ? 'Regarding your comments, we retain only certain information that we are legally required to retain, for the minimum retention period prescribed by law.'
                    : 'U vezi s vašim komentarima, čuvamo samo određene informacije koje smo dužni čuvati na osnovu zakona, tokom perioda koji je istim propisan kao minimalan period zadržavanja.'
                }</p>

                <p className="mb-4">{en
                    ? 'The text of the comment remains stored in the online news archive together with the article text.'
                    : 'S tim da tekst komentara ostaje sačuvan u online arhivi vijesti zajedno s tekstom vijesti.'
                }</p>

                <h2 className="text-xl font-semibold mt-6 mb-2">
                    {en ? 'Cookies' : 'Kolačići'}
                </h2>
                <p className="mb-4">{en
                    ? 'Our site uses our own cookies as well as third-party cookies, which allow you to use and navigate the site more easily.'
                    : 'Na našem sajtu nalaze se naši kolačići, kao i kolačići trećih strana, koji vam omogućavaju da na lakši način koristite sajt i krećete se po njemu.'
                }</p>

                <p className="mb-4">{en
                    ? 'Some of these cookies are also used for analytics, serving certain advertisements, or suggesting certain articles.'
                    : 'Neki od tih kolačića koriste se i u svrhu analitike, plasiranja određenih reklama ili predlaganja određenih vijesti.'
                }</p>

                <p className="mb-4">{en
                    ? 'On your first visit to the site, a notification will appear about all the cookies we use, what data they collect and for what purposes.'
                    : 'Prilikom prve posjete sajtu, iskočit će vam obavještenje o svim kolačićima koje koristimo, koje podatke oni prikupljaju i u koje svrhe.'
                }</p>

                <p className="mb-4">{en
                    ? 'All cookies are grouped into the following categories: necessary, performance, marketing, statistics, and other.'
                    : 'Svi kolačići svrstani su u sljedeće kategorije: neophodni, za unapređenje rada sajta, marketing, statistika i ostali.'
                }</p>

                <p className="mb-4">{en
                    ? 'Without necessary cookies it is not possible to browse and use our site. For all other cookies you will have the option to decide whether you wish to accept their use or not.'
                    : 'Bez neophodnih kolačića nije moguće pretraživati i koristiti naš sajt. Za sve ostale kolačiće imat ćete mogućnost da odlučite da li želite prihvatiti njihovo korištenje ili ne.'
                }</p>

                <p className="mb-4">{en
                    ? 'If you do not accept the use of such cookies, this will not prevent you from using the site, but it may affect the functionality of its use.'
                    : 'Ako ne prihvatite korištenje takvih kolačića, to vas neće onemogućiti da koristite sajt, ali može utjecati na funkcionalnost njegovog korištenja.'
                }</p>

                <h2 className="text-xl font-semibold mt-6 mb-2">
                    {en ? 'Contact and Complaints' : 'Kontakt i prigovori'}
                </h2>
                <p className="mb-4">{en
                    ? <>All questions and requests regarding your data may be sent to our Data Protection Officer at the following email address: <a href="mailto:studijeodbrambenihsistema@gmail.com" className="text-blue-600">studijeodbrambenihsistema@gmail.com</a>. At any time you may lodge a complaint regarding the processing of your personal data with the national data protection authorities in your country.</>
                    : <>Sva pitanja, kao i zahtjeve u vezi sa vašim podacima, možete postaviti našem Službeniku za zaštitu podataka o ličnosti na sledeću e-mail adresu: <a href="mailto:studijeodbrambenihsistema@gmail.com" className="text-blue-600">studijeodbrambenihsistema@gmail.com</a>. U svakom trenutku možete uložiti prigovor u vezi sa obradom vaših ličnih podataka, nacionalnim tijelima za zaštitu ličnih podataka u vašoj zemlji.</>
                }</p>

                <p className="mb-4">{en
                    ? 'studijeodbrambenihsistema.com reserves the right to amend or supplement this Privacy Policy. For significant changes, studijeodbrambenihsistema.com may notify users by email or by publishing a notice on the blog.'
                    : 'studijeodbrambenihsistema.com zadržava pravo da izmijeni ili dopuni ovu Politika privatnosti. O važnim izmjenama i dopunama studijeodbrambenihsistema.com može obavijestiti korisnike putem e-maila ili objavljivanjem na blogu.'
                }</p>

                <p className="mb-4">{en
                    ? 'By using any content on the blog studijeodbrambenihsistema.com, you are deemed to be aware of the latest Terms of Use as well as the Privacy Policy.'
                    : 'Korištenjem bilo kojeg sadržaja na blogu studijeodbrambenihsistema.com smatra se da ste upoznati s najnovijim pravilima o uslovima korištenja, kao i s Politikom privatnosti.'
                }</p>

                <p className="text-sm text-gray-600 mt-8">{en ? 'Last updated: January 25, 2026.' : 'Posljednja izmjena: 25. 1. 2026.'}</p>
            </section>

            <div className="mt-auto">
                <Footer />
            </div>
        </main>
    );
}
